import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import pt from './locales/pt.json';
import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en', 'es'],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      // `path` primeiro: a URL é a fonte da verdade do idioma (ver
      // src/i18n/routing.js). Sem isto o primeiro render usaria o valor
      // do localStorage e piscaria no idioma errado antes de o roteador
      // corrigir. Um primeiro segmento que não seja idioma (`/pixrow`)
      // não casa com supportedLngs e cai para o próximo detector.
      order: ['path', 'localStorage'],
      lookupFromPathIndex: 0,
      lookupLocalStorage: 'p2a_lang',
      caches: ['localStorage'],
    },
    returnObjects: false,
  });

export default i18n;
